"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassesTags = void 0;
class ClassesTags {
    constructor() { }
}
exports.ClassesTags = ClassesTags;
ClassesTags.Active = "active";
ClassesTags.Loading = "loading";
ClassesTags.Toggled = "toggled";
ClassesTags.Invalid = "invalid";
//# sourceMappingURL=ClassesTags.js.map